import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class IdGeneratorService {

    lastId = 0;

    public getNextId() : number {
        return this.lastId--;
    }
}